import { render, staticRenderFns } from "./NFCWriter.vue?vue&type=template&id=49a7032f&scoped=true&"
import script from "./NFCWriter.vue?vue&type=script&lang=js&"
export * from "./NFCWriter.vue?vue&type=script&lang=js&"
import style0 from "./NFCWriter.vue?vue&type=style&index=0&id=49a7032f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a7032f",
  null
  
)

export default component.exports